"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
function isOverlapped(el) {
    const allMapPins = el.parentElement.children;
    return (Array.from(allMapPins).filter((pin) => pin.offsetLeft === el.offsetLeft && pin.offsetTop === el.offsetTop).length > 1);
}
function extendOverlappedMapPins(el) {
    let overlappedElCount = 0;
    const allMapPins = el.parentElement.children;
    Array.from(allMapPins)
        // ignore invisible clusters related to other zoom levels
        .filter((pin) => pin.style.display !== 'none' && pin.childNodes.length)
        .forEach((pin) => {
        if (pin.offsetLeft === el.offsetLeft && pin.offsetTop === el.offsetTop) {
            overlappedElCount++;
        }
        else {
            // does not count and affect other pins that is not intersects
            return;
        }
        // NOTE: Left the first overlapped pin on the initial position.
        if (overlappedElCount > 1) {
            pin.style.left = `${pin.offsetLeft + overlappedElCount * 10}px`;
        }
    });
}
function elementIndexUpEvent(event) {
    event.currentTarget.style.zIndex = '2';
    if (isOverlapped(event.currentTarget)) {
        extendOverlappedMapPins(event.currentTarget);
    }
}
function elementIndexUnsetEvent(event) {
    event.currentTarget.style.zIndex = '';
}
const MapPinButton = styled_components_1.default.div.attrs({
    role: `button`,
})(({ selected, activePinColor, theme: { colors }, theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    zIndex: selected ? 1 : 0,
    '.map-pin-wrapper': {
        cursor: 'auto',
        ':after': Object.assign(Object.assign({}, theme.map.pinWrapper), { borderTopColor: selected
                ? activePinColor
                    ? activePinColor
                    : colors.activePinWrapper
                : colors.pinWrapper }),
    },
    '.map-pin-content': Object.assign(Object.assign({}, theme.map.pinContent), { backgroundColor: selected
            ? activePinColor
                ? activePinColor
                : colors.activePinWrapper
            : colors.pinWrapper }),
}));
const MapPinLayout = (0, react_1.forwardRef)((props, ref) => {
    const { children, selected = false, onClick, className } = props, divProps = __rest(props, ["children", "selected", "onClick", "className"]);
    const alternativeRef = (0, react_1.useRef)(null);
    const divRef = (ref || alternativeRef);
    return (react_1.default.createElement(MapPinButton, Object.assign({ ref: divRef, onMouseEnter: elementIndexUpEvent, onMouseLeave: elementIndexUnsetEvent, tabIndex: 0, selected: selected, onClick: onClick, onKeyPress: onClick, className: className }, divProps),
        react_1.default.createElement("div", { className: "map-pin-wrapper" },
            react_1.default.createElement("div", { className: "map-pin-content" }, children))));
});
MapPinLayout.displayName = 'MapPinWrapper';
exports.default = MapPinLayout;
//# sourceMappingURL=MapPinLayout.js.map